export enum STARTING_POSITION {
    HIGH = 'high',
    LOW = 'low'
};

export const POLYLINE_HEIGHT = 20;
